import router from './router'
import store from './store'
import { Message } from 'element-ui'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import { getUserInfo } from '@/store/auth' // get token from cookie
import { asyncRouters } from '@/router/index'
NProgress.configure({ showSpinner: false }) // NProgress Configuration

router.beforeEach((to,from,next)=>{
  NProgress.start()
  // if(true){
  if(getUserInfo()){
    if (to.path === '/login') { // 已登录，直接加载
      next({ path: '/' })
      NProgress.done()
    }else{
      if(store.getters.add_routes.length===0){
        store.dispatch('user/getPermissionRoutes').then((accessRoutes)=>{
          router.$addRoutes(accessRoutes)
          next({...to,replace: true})
        })
      }else{
        next()
      }
      // if(store.getters.add_routes.length===0){
      //   console.log(1)
      //   store.dispatch('user/setRoutersTest',asyncRouters).then(()=>{
      //     router.$addRoutes(asyncRouters)
      //   })
      // }
      // next()
    }
  }else{
    // 未登录
    if (to.path === '/login' ) {
    // || to.path=='/dataCenter'
      console.log(to);

      // router.$addRoutes(accessRoutes)
      next()
    } else {
      next(`/login?redirect=${to.path}`)
      NProgress.done()
    }
  }
})

router.afterEach(() => {
  NProgress.done()
})



// WEBPACK FOOTER //
// ./src/permission.js